import { t as e } from "./configEditor.translations-DXHXmRwX.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { Icon as r, Typography as i, cn as a } from "@vintecc/components";
import { faClose as o } from "@vintecc/pro-light-svg-icons";
//#region src/services/monacoService.ts
var s = null, c = null;
function l() {
	return c ||= (async () => {
		let { loader: e } = await import("@monaco-editor/react");
		window.__MONACO_VS_PATH__ && e.config({ paths: { vs: window.__MONACO_VS_PATH__ } });
		let t = await e.init();
		return s = t, t;
	})(), c;
}
function u() {
	if (!s) throw Error("Monaco has not been initialized yet. Call initMonaco() first.");
	return s;
}
//#endregion
//#region src/components/PanelHeader.tsx
var d = ({ onClose: s, icon: c, title: l, className: u, children: d }) => {
	let { t: f } = e();
	return /* @__PURE__ */ n("div", {
		className: a("pl-8 pr-4 py-5 border-b border-grey-200", u),
		style: { background: "linear-gradient(308.68deg, #FFFFFF 49.8%, #F7F7F7 88.54%)" },
		children: [/* @__PURE__ */ n("div", {
			className: "flex justify-between items-center",
			children: [/* @__PURE__ */ n("div", {
				className: "flex items-center gap-1",
				children: [c && /* @__PURE__ */ t("div", {
					className: "flex justify-center items-center h-5 w-5",
					children: c
				}), /* @__PURE__ */ t(i, {
					variant: "strong",
					children: l
				})]
			}), s && /* @__PURE__ */ t("button", {
				className: "flex justify-center items-center w-8 h-7 cursor-pointer text-grey-600",
				onClick: s,
				"aria-label": f("configEditor.actions.close", "Close"),
				children: /* @__PURE__ */ t(r, {
					icon: o,
					size: "2xl"
				})
			})]
		}), d]
	});
};
//#endregion
export { u as n, l as r, d as t };

//# sourceMappingURL=PanelHeader-D-Qg1q2l.js.map